export const BACKEND_URL = "https://sec-sant-back.herokuapp.com/";
export const FRONTEND_URL = "https://secret-santa.itsthenikolai.com/#/";
